import { CheckoutService } from 'services/checkout.service';
import { isShippingAndBillingAddressSame } from 'services/cartUtils';
import { ModalService } from 'services/modal.service';
import { ContactInfoForm } from 'components/contactInfoForm/contactInfoForm';
import { ShippingAddressForm } from 'components/shippingAddressForm/shippingAddressForm';
import { AddressVerificationForm } from 'components/addressVerificationForm/addressVerificationForm';
import { AddressVerificationService } from 'services/addressVerification.service';

import template from './editContactAndDelivery.html';

export const EditContactAndDelivery = angular
    .module('checkout.components.editContactAndDelivery', [
        'ngMaterial',
        AddressVerificationForm,
        AddressVerificationService,
        ModalService,
        CheckoutService,
        ContactInfoForm,
        ShippingAddressForm
    ]).service('editContactAndDeliveryService', (modalService) => {
        return {
            open: (
                cart,
                phoneNumberRequired,
                showShippingAsBilling,
                $event, onLoginClicked,
                isLoggedIn,
                isShippingRequired,
                useAddressVerification = false,
                useNewCarts = false
            ) => {
                return modalService.open({
                    $event,
                    template: `
                        <edit-contact-and-delivery
                            cart="cart"
                            phone-number-required="phoneNumberRequired"
                            show-shipping-as-billing="showShippingAsBilling"
                            on-login-clicked="onLoginClicked"
                            is-logged-in="isLoggedIn"
                            is-shipping-required="isShippingRequired"
                            use-new-carts="useNewCarts"
                            use-address-verification="useAddressVerification"
                            layout="column">
                        </edit-contact-and-delivery>`,
                    data: {
                        cart,
                        phoneNumberRequired,
                        showShippingAsBilling,
                        onLoginClicked,
                        isLoggedIn,
                        isShippingRequired,
                        useAddressVerification,
                        useNewCarts
                    }
                });
            }
        };
    }).component('editContactAndDelivery', {
        bindings: {
            cart: '<',
            phoneNumberRequired: '<',
            showShippingAsBilling: '<',
            onLoginClicked: '<',
            isLoggedIn: '<',
            isShippingRequired: '<',
            useAddressVerification: '<',
            useNewCarts: '<'
        },
        template,
        controller: class EditContactAndDeliveryController {
            constructor(
                $mdDialog,
                addressVerificationService,
                checkoutService
            ) {
                angular.extend(this, {
                    $mdDialog,
                    addressVerificationService,
                    checkoutService
                });

                this.updateAddress = this.updateAddress.bind(this);
            }

            $onInit() {
                this.setStateFromCart();
            }

            setStateFromCart() {
                this.contactInfoModel = {
                    phone: this.cart.contactInfo.phoneNumber,
                    email: this.cart.contactInfo.email,
                    emailOptIn: this.cart.emailOptIn
                };

                this.shippingAddressModel = angular.copy(this.cart.shippingAddress);

                if (isShippingAndBillingAddressSame(this.cart) || !this.isShippingRequired) {
                    this.shippingAddressModel.shippingAsBilling = true;
                }
            }

            save() {
                if (this.contactAndDeliveryForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.contactInfoForm']);
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.addressForm']);
                    return;
                }

                this.isUpdatingCart = true;

                if (this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.shippingAddressModel)
                        .then(({ verified, changes, recommendations }) => {
                            if (!verified || changes) {
                                this.isUpdatingCart = false;

                                this.showAddressSuggestion = true;
                                this.addressRecommendations = recommendations;
                                this.addressChanges = changes;
                            } else {
                                this.saveFormData();
                            }
                        });
                } else {
                    this.saveFormData();
                }
            }

            saveFormData() {
                const saveFormData = this.useNewCarts ?
                    this.checkoutService.saveContactInfoAndShippingAddress :
                    this.checkoutService.applyContactInfoAndShippingAddressToCart;
                saveFormData({
                    contactInfoModel: this.contactInfoModel,
                    shippingAddressModel: this.shippingAddressModel
                }).then((cart) => {
                    this.$mdDialog.hide(cart);
                }).catch((err) => {
                    this.checkoutService.showErrorDialog(err);
                }).finally(() => {
                    this.showAddressSuggestion = false;
                    this.isUpdatingCart = false;
                });
            }

            updateAddress(newAddress) {
                this.addressRecommendations = null;
                this.addressChanges = null;

                if (!newAddress) {
                    this.showAddressSuggestion = false;
                } else {
                    this.shippingAddressModel = { ...this.shippingAddressModel, ...newAddress };
                    this.isUpdatingCart = true;
                    this.saveFormData();
                }
            }

            cancel() {
                this.$mdDialog.cancel();
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editContactAndDelivery/editContactAndDelivery.js